module.exports = __webpack_public_path__ + "assets/img/65_316_1.da2b7cdf.jpg";